import { createRouter, createWebHistory } from 'vue-router'
import { previousRoute } from '@/router/history'

export const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        // Global Routes (without tenant)
        {
            path: '/login',
            name: 'login',
            component: () => import('@/pages/Login.vue')
        },

        {
            path: '/auth/callback',
            name: 'auth.callback',
            component: () => import('@/pages/AuthCallback.vue')
        },

        {
            path: '/quote-lite',
            name: 'quote-lite.create',
            component: () => import('@/pages/quote-lite/Create.vue'),
            meta: { public: true }
        },

        {
            path: '/ql/:token/edit',
            name: 'quote-lite.edit',
            component: () => import('@/pages/quote-lite/Edit.vue'),
            meta: { public: true }
        },

        {
            path: '/ql/approve/:token',
            name: 'quote-lite.approval-confirm',
            component: () => import('@/pages/quote-lite/ConfirmApproval.vue'),
            meta: { public: true }
        },

        {
            path: '/ql/email/verify/:token',
            name: 'quote-lite.email-verification-confirm',
            component: () => import('@/pages/quote-lite/ConfirmEmailVerification.vue'),
            meta: { public: true }
        },

        {
            path: '/ql/:token',
            name: 'quote-lite.view',
            component: () => import('@/pages/quote-lite/View.vue'),
            meta: { public: true }
        },

        // Dashboard / Home (redirect to products with tenant)
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/:tenantId',
            redirect: to => `/${to.params.tenantId}/dashboard`
        },

        {
            path: '/:tenantId/dashboard',
            name: 'dashboard.index',
            component: () => import('@/pages/dashboard/Index.vue')
        },

        {
            path: '/:tenantId/apps',
            name: 'apps.index',
            component: () => import('@/pages/admin/apps/Index.vue')
        },

        // Profile
        {
            path: '/:tenantId/profile',
            name: 'profile',
            component: () => import('@/pages/admin/Profile.vue')
        },

        // Import Admin
        {
            path: '/:tenantId/import-admin',
            name: 'import-admin',
            component: () => import('@/pages/admin/import-admin/Index.vue')
        },

        // Email Log
        {
            path: '/:tenantId/email-log',
            name: 'email-log',
            component: () => import('@/pages/admin/email-log/Index.vue')
        },

        // Media Library (redirect alle rotte entity generiche)
        {
            path: '/:tenantId/media-library',
            name: 'media-library.index',
            redirect: to => ({ name: 'entity.index', params: { tenantId: to.params.tenantId, entityType: 'media' } })
        },
        {
            path: '/:tenantId/media-library/create',
            name: 'media-library.create',
            redirect: to => ({ name: 'entity.create', params: { tenantId: to.params.tenantId, entityType: 'media' } })
        },
        {
            path: '/:tenantId/media-library/:id/edit',
            name: 'media-library.edit',
            redirect: to => ({ name: 'entity.edit', params: { tenantId: to.params.tenantId, entityType: 'media', id: to.params.id } })
        },

        // Quote
        {
            path: '/:tenantId/quotes',
            name: 'quote.index',
            component: () => import('@/pages/admin/quote/Index.vue')
        },
        {
            path: '/:tenantId/quote/requests',
            name: 'quote.sales-request.index',
            component: () => import('@/pages/admin/quote/sales-request/Index.vue')
        },
        {
            path: '/:tenantId/quote/requests/create',
            name: 'quote.sales-request.create',
            component: () => import('@/pages/admin/quote/sales-request/Create.vue')
        },
        {
            path: '/:tenantId/quote/requests/:id/edit',
            name: 'quote.sales-request.edit',
            component: () => import('@/pages/admin/quote/sales-request/Edit.vue')
        },
        {
            path: '/:tenantId/quote/quotes',
            name: 'quote.quote.index',
            component: () => import('@/pages/admin/quote/quote/Index.vue')
        },
        {
            path: '/:tenantId/quote/quotes/create',
            name: 'quote.quote.create',
            component: () => import('@/pages/admin/quote/quote/Create.vue')
        },
        {
            path: '/:tenantId/quote/quotes/:id/edit',
            name: 'quote.quote.edit',
            component: () => import('@/pages/admin/quote/quote/Edit.vue')
        },
        {
            path: '/:tenantId/quote/accounts',
            name: 'quote.account.index',
            component: () => import('@/pages/admin/quote/account/Index.vue')
        },
        {
            path: '/:tenantId/quote/accounts/create',
            name: 'quote.account.create',
            component: () => import('@/pages/admin/quote/account/Create.vue')
        },
        {
            path: '/:tenantId/quote/accounts/:id/edit',
            name: 'quote.account.edit',
            component: () => import('@/pages/admin/quote/account/Edit.vue')
        },
        {
            path: '/:tenantId/quote/people',
            name: 'quote.person.index',
            component: () => import('@/pages/admin/quote/person/Index.vue')
        },
        {
            path: '/:tenantId/quote/people/create',
            name: 'quote.person.create',
            component: () => import('@/pages/admin/quote/person/Create.vue')
        },
        {
            path: '/:tenantId/quote/people/:id/edit',
            name: 'quote.person.edit',
            component: () => import('@/pages/admin/quote/person/Edit.vue')
        },
        {
            path: '/:tenantId/quote/follow-ups',
            name: 'quote.follow-up.index',
            component: () => import('@/pages/admin/quote/Placeholder.vue'),
            meta: { quotePage: 'followUps' }
        },

        // Reception
        {
            path: '/:tenantId/reception',
            name: 'reception.index',
            component: () => import('@/pages/admin/reception/Index.vue')
        },
        {
            path: '/:tenantId/reception/calls',
            name: 'reception.call.index',
            component: () => import('@/pages/admin/reception/call/Index.vue')
        },
        {
            path: '/:tenantId/reception/calls/:id/edit',
            name: 'reception.call.edit',
            component: () => import('@/pages/admin/reception/call/Edit.vue')
        },

        // Stats
        {
            path: '/:tenantId/stats/sales',
            name: 'stats.sales',
            component: () => import('@/pages/admin/stats/SaleStats.vue')
        },
        {
            path: '/:tenantId/stats/quotes',
            name: 'stats.quotes',
            component: () => import('@/pages/admin/stats/QuoteStats.vue')
        },

        // Discount
        {
            path: '/:tenantId/discounts',
            name: 'discount.index',
            component: () => import('@/pages/admin/discount/Index.vue')
        },
        {
            path: '/:tenantId/discounts/create',
            name: 'discount.create',
            component: () => import('@/pages/admin/discount/Create.vue')
        },
        {
            path: '/:tenantId/discounts/:id/edit',
            name: 'discount.edit',
            component: () => import('@/pages/admin/discount/Edit.vue')
        },

        // Discount group
        {
            path: '/:tenantId/discount-groups',
            name: 'discount-group.index',
            component: () => import('@/pages/admin/discount-group/Index.vue')
        },
        {
            path: '/:tenantId/discount-groups/create',
            name: 'discount-group.create',
            component: () => import('@/pages/admin/discount-group/Create.vue')
        },
        {
            path: '/:tenantId/discount-groups/:id/edit',
            name: 'discount-group.edit',
            component: () => import('@/pages/admin/discount-group/Edit.vue')
        },

        // Configuration
        {
            path: '/:tenantId/configuration',
            name: 'configuration',
            component: () => import('@/pages/admin/configuration/Index.vue')
        },

        {
            path: '/:tenantId/configuration/users',
            name: 'configuration.user.index',
            component: () => import('@/pages/admin/user/Index.vue')
        },

        {
            path: '/:tenantId/configuration/users/create',
            name: 'configuration.user.create',
            component: () => import('@/pages/admin/user/Create.vue')
        },

        {
            path: '/:tenantId/configuration/users/:id/edit',
            name: 'configuration.user.edit',
            component: () => import('@/pages/admin/user/Edit.vue')
        },

        {
            path: '/:tenantId/configuration/nichera',
            name: 'configuration.nichera',
            component: () => import('@/pages/admin/configuration/KartioEdit.vue')
        },

        {
            path: '/:tenantId/configuration/reply-tasks',
            name: 'configuration.reply-tasks',
            component: () => import('@/pages/admin/configuration/ReplyTasksEdit.vue')
        },

        {
            path: '/:tenantId/configuration/store-locator',
            name: 'configuration.store-locator',
            component: () => import('@/pages/admin/configuration/StoreLocatorEdit.vue')
        },

        // Reply Task Assignment by Sender Address
        {
            path: '/:tenantId/configuration/reply-tasks/assignments',
            name: 'configuration.reply-tasks.assignment-by-sender.index',
            component: () => import('@/pages/admin/reply-task-assignment-by-sender/Index.vue')
        },
        {
            path: '/:tenantId/configuration/reply-tasks/assignments/create',
            name: 'configuration.reply-tasks.assignment-by-sender.create',
            component: () => import('@/pages/admin/reply-task-assignment-by-sender/Create.vue')
        },
        {
            path: '/:tenantId/configuration/reply-tasks/assignments/:id/edit',
            name: 'configuration.reply-tasks.assignment-by-sender.edit',
            component: () => import('@/pages/admin/reply-task-assignment-by-sender/Edit.vue')
        },

        // Locale configuration
        {
            path: '/:tenantId/locale-configuration',
            name: 'locale-configuration',
            component: () => import('@/pages/admin/locale-configuration/Edit.vue')
        },

        {
            path: '/:tenantId/builder/global-settings',
            name: 'builder.global-settings',
            component: () => import('@/pages/admin/builder/EmbeddedSettings.vue'),
            props: {
                title: 'Global settings',
                nuxtPath: '/_settings/global-defaults',
            },
        },

        {
            path: '/:tenantId/builder/themes',
            name: 'builder.themes',
            component: () => import('@/pages/admin/builder/EmbeddedSettings.vue'),
            props: {
                title: 'Themes',
                nuxtPath: '/_settings/themes',
            },
        },

        // Print Handling Charge
        {
            path: '/:tenantId/print-handling-charges',
            name: 'print-handling-charge.index',
            component: () => import('@/pages/admin/print-handling-charge/Index.vue')
        },
        {
            path: '/:tenantId/print-handling-charges/create',
            name: 'print-handling-charge.create',
            component: () => import('@/pages/admin/print-handling-charge/Create.vue')
        },
        {
            path: '/:tenantId/print-handling-charges/:id/edit',
            name: 'print-handling-charge.edit',
            component: () => import('@/pages/admin/print-handling-charge/Edit.vue')
        },

        // Customer
        {
            path: '/:tenantId/customers',
            name: 'customer.index',
            component: () => import('@/pages/admin/customer/Index.vue')
        },
        {
            path: '/:tenantId/customers/create',
            name: 'customer.create',
            component: () => import('@/pages/admin/customer/Create.vue')
        },
        {
            path: '/:tenantId/customers/:id/edit',
            name: 'customer.edit',
            component: () => import('@/pages/admin/customer/Edit.vue')
        },
        {
            path: '/:tenantId/customers/import',
            name: 'customer.import',
            component: () => import('@/pages/admin/customer/Import.vue')
        },

        // Ticket
        {
            path: '/:tenantId/tickets',
            name: 'ticket.index',
            component: () => import('@/pages/admin/ticket/Index.vue')
        },
        {
            path: '/:tenantId/tickets/create',
            name: 'ticket.create',
            component: () => import('@/pages/admin/ticket/Create.vue')
        },
        {
            path: '/:tenantId/tickets/:id/edit',
            name: 'ticket.edit',
            component: () => import('@/pages/admin/ticket/Edit.vue')
        },
        {
            path: '/:tenantId/contracts',
            name: 'contract.index',
            component: () => import('@/pages/admin/contract/Index.vue')
        },
        {
            path: '/:tenantId/contracts/create',
            name: 'contract.create',
            component: () => import('@/pages/admin/contract/Create.vue')
        },
        {
            path: '/:tenantId/contracts/:id/edit',
            name: 'contract.edit',
            component: () => import('@/pages/admin/contract/Edit.vue')
        },
        {
            path: '/:tenantId/contacts',
            name: 'contact.index',
            component: () => import('@/pages/admin/contact/Index.vue')
        },
        {
            path: '/:tenantId/contacts/create',
            name: 'contact.create',
            component: () => import('@/pages/admin/contact/Create.vue')
        },
        {
            path: '/:tenantId/contacts/:id/edit',
            name: 'contact.edit',
            component: () => import('@/pages/admin/contact/Edit.vue')
        },

        // Notification
        {
            path: '/:tenantId/notifications',
            name: 'notification.index',
            component: () => import('@/pages/admin/notification/Index.vue')
        },
        {
            path: '/:tenantId/notifications/:id/edit',
            name: 'notification.edit',
            component: () => import('@/pages/admin/notification/Edit.vue')
        },

        // Currency Rate
        {
            path: '/:tenantId/currency-rates',
            name: 'currency-rate.index',
            component: () => import('@/pages/admin/currency-rate/Index.vue')
        },
        {
            path: '/:tenantId/currency-rates/:id/edit',
            name: 'currency-rate.edit',
            component: () => import('@/pages/admin/currency-rate/Edit.vue')
        },

        // Attachment
        {
            path: '/:tenantId/attachments',
            name: 'attachment.index',
            component: () => import('@/pages/admin/attachment/Index.vue')
        },
        {
            path: '/:tenantId/attachments/create',
            name: 'attachment.create',
            component: () => import('@/pages/admin/attachment/Create.vue')
        },
        {
            path: '/:tenantId/attachments/:id/edit',
            name: 'attachment.edit',
            component: () => import('@/pages/admin/attachment/Edit.vue')
        },

        // Product
        {
            path: '/:tenantId/products',
            name: 'product.index',
            component: () => import('@/pages/admin/product/Index.vue')
        },
        {
            path: '/:tenantId/products/create',
            name: 'product.create',
            component: () => import('@/pages/admin/product/Create.vue')
        },
        {
            path: '/:tenantId/products/:id/edit',
            name: 'product.edit',
            component: () => import('@/pages/admin/product/Edit.vue')
        },

        // Product types
        {
            path: '/:tenantId/product-types',
            name: 'product-type.index',
            component: () => import('@/pages/admin/product-type/Index.vue')
        },
        {
            path: '/:tenantId/product-types/create',
            name: 'product-type.create',
            component: () => import('@/pages/admin/product-type/Create.vue')
        },
        {
            path: '/:tenantId/product-types/:id/edit',
            name: 'product-type.edit',
            component: () => import('@/pages/admin/product-type/Edit.vue')
        },

        // Product attribute
        {
            path: '/:tenantId/product-attributes',
            name: 'product-attribute.index',
            component: () => import('@/pages/admin/product-attribute/Index.vue')
        },
        {
            path: '/:tenantId/product-attributes/create',
            name: 'product-attribute.create',
            component: () => import('@/pages/admin/product-attribute/Create.vue')
        },
        {
            path: '/:tenantId/product-attributes/:id/edit',
            name: 'product-attribute.edit',
            component: () => import('@/pages/admin/product-attribute/Edit.vue')
        },

        // Courier
        {
            path: '/:tenantId/couriers',
            name: 'courier.index',
            component: () => import('@/pages/admin/courier/Index.vue')
        },
        {
            path: '/:tenantId/couriers/create',
            name: 'courier.create',
            component: () => import('@/pages/admin/courier/Create.vue')
        },
        {
            path: '/:tenantId/couriers/:id/edit',
            name: 'courier.edit',
            component: () => import('@/pages/admin/courier/Edit.vue')
        },

        // Shipping
        {
            path: '/:tenantId/shipping',
            name: 'shipping.index',
            component: () => import('@/pages/admin/shipping/Index.vue')
        },
        {
            path: '/:tenantId/shipping/create',
            name: 'shipping.create',
            component: () => import('@/pages/admin/shipping/Create.vue')
        },
        {
            path: '/:tenantId/shipping/:id/edit',
            name: 'shipping.edit',
            component: () => import('@/pages/admin/shipping/Edit.vue')
        },

        // Task
        {
            path: '/:tenantId/tasks',
            name: 'task.index',
            component: () => import('@/pages/admin/task/Index.vue')
        },

        // REST API User
        {
            path: '/:tenantId/rest-api-users',
            name: 'rest-api-user.index',
            component: () => import('@/pages/admin/rest-api-user/Index.vue')
        },
        {
            path: '/:tenantId/rest-api-users/create',
            name: 'rest-api-user.create',
            component: () => import('@/pages/admin/rest-api-user/Create.vue')
        },
        {
            path: '/:tenantId/rest-api-users/:id/edit',
            name: 'rest-api-user.edit',
            component: () => import('@/pages/admin/rest-api-user/Edit.vue')
        },

        // Order
        {
            path: '/:tenantId/orders',
            name: 'order.index',
            component: () => import('@/pages/admin/order/Index.vue')
        },
        {
            path: '/:tenantId/orders/:id/edit',
            name: 'order.edit',
            component: () => import('@/pages/admin/order/Edit.vue')
        },

        // Supplier Control Panel
        {
            path: '/:tenantId/supplier-control-panel',
            name: 'supplier-control-panel.index',
            component: () => import('@/pages/admin/supplier-control-panel/SettingIndex.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/settings/:id/edit',
            name: 'supplier-control-panel.edit-setting',
            component: () => import('@/pages/admin/supplier-control-panel/SettingEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/general-profit/:id/edit',
            name: 'supplier-control-panel.edit-general-profit',
            component: () => import('@/pages/admin/supplier-control-panel/GeneralProfitEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/category-profit/:id/edit',
            name: 'supplier-control-panel.edit-category-profit',
            component: () => import('@/pages/admin/supplier-control-panel/CategoryProfitEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/product-profit/:id/edit',
            name: 'supplier-control-panel.edit-product-profit',
            component: () => import('@/pages/admin/supplier-control-panel/ProductProfitEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/product-translator',
            name: 'supplier-control-panel.product-translator',
            component: () => import('@/pages/admin/supplier-control-panel/ProductTranslatorIndex.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/product-translator/:id/edit',
            name: 'supplier-control-panel.product-translator.edit',
            component: () => import('@/pages/admin/supplier-control-panel/ProductTranslatorEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/grouped-translator/:id/edit',
            name: 'supplier-control-panel.edit-grouped-translator',
            component: () => import('@/pages/admin/supplier-control-panel/GroupedTranslatorEdit.vue')
        },
        {
            path: '/:tenantId/supplier-control-panel/product-shared-translator/:id/edit',
            name: 'supplier-control-panel.edit-product-shared-translator',
            component: () => import('@/pages/admin/supplier-control-panel/ProductSharedTranslatorEdit.vue')
        },

        // Public Tokens
        {
            path: '/:tenantId/public-tokens',
            name: 'public-token.edit',
            component: () => import('@/pages/admin/public-token/Edit.vue')
        },

        // Calcura
        {
            path: '/:tenantId/calcura/calculators',
            name: 'calcura.calculator.index',
            component: () => import('@/pages/admin/calcura-calculator/Index.vue')
        },
        {
            path: '/:tenantId/calcura/calculators/create',
            name: 'calcura.calculator.create',
            component: () => import('@/pages/admin/calcura-calculator/Create.vue')
        },
        {
            path: '/:tenantId/calcura/calculators/:id/edit',
            name: 'calcura.calculator.edit',
            component: () => import('@/pages/admin/calcura-calculator/Edit.vue')
        },

        {
            path: '/:tenantId/calcura/orders',
            name: 'calcura.order.index',
            component: () => import('@/pages/admin/calcura-order/Index.vue')
        },

        {
            path: '/:tenantId/calcura/orders/:id/edit',
            name: 'calcura.order.edit',
            component: () => import('@/pages/admin/calcura-order/Edit.vue')
        },

        // Reply Tasks
        {
            path: '/:tenantId/reply-tasks',
            name: 'reply-task.index',
            component: () => import('@/pages/admin/reply-task/Index.vue')
        },
        {
            path: '/:tenantId/reply-task/:id/edit',
            name: 'reply-task.edit',
            component: () => import('@/pages/admin/reply-task/Edit.vue')
        },

        // TamePulse
        {
            path: '/:tenantId/tamepulse/connections',
            name: 'tamepulse.connection',
            component: () => import('@/pages/admin/tamepulse/connections/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/connections/create',
            name: 'tamepulse.connection.create',
            component: () => import('@/pages/admin/tamepulse/connections/Create.vue')
        },
        {
            path: '/:tenantId/tamepulse/connections/:id/edit',
            name: 'tamepulse.connection.edit',
            component: () => import('@/pages/admin/tamepulse/connections/Edit.vue')
        },
        {
            path: '/:tenantId/tamepulse/chat',
            name: 'tamepulse.chat.index',
            component: () => import('@/pages/admin/tamepulse/chat/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/playbooks',
            name: 'tamepulse.playbook.index',
            component: () => import('@/pages/admin/tamepulse/playbook/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/playbooks/create',
            name: 'tamepulse.playbook.create',
            component: () => import('@/pages/admin/tamepulse/playbook/Create.vue')
        },
        {
            path: '/:tenantId/tamepulse/playbooks/:id/edit',
            name: 'tamepulse.playbook.edit',
            component: () => import('@/pages/admin/tamepulse/playbook/Edit.vue')
        },
        {
            path: '/:tenantId/tamepulse/playbooks/:id/runs',
            name: 'tamepulse.playbook.runs',
            component: () => import('@/pages/admin/tamepulse/playbook/RunHistory.vue')
        },
        {
            path: '/:tenantId/tamepulse/templates',
            name: 'tamepulse.template.index',
            component: () => import('@/pages/admin/tamepulse/templates/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/approvals',
            name: 'tamepulse.approval.index',
            component: () => import('@/pages/admin/tamepulse/approval/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/approvals/:id',
            name: 'tamepulse.approval.show',
            component: () => import('@/pages/admin/tamepulse/approval/Show.vue')
        },
        {
            path: '/:tenantId/tamepulse/skills',
            name: 'tamepulse.skill.index',
            component: () => import('@/pages/admin/tamepulse/skill/Index.vue')
        },
        {
            path: '/:tenantId/tamepulse/skills/create',
            name: 'tamepulse.skill.create',
            component: () => import('@/pages/admin/tamepulse/skill/Create.vue')
        },
        {
            path: '/:tenantId/tamepulse/skills/:id/edit',
            name: 'tamepulse.skill.edit',
            component: () => import('@/pages/admin/tamepulse/skill/Edit.vue')
        },
        {
            path: '/:tenantId/tamepulse/messages',
            name: 'tamepulse.message.index',
            component: () => import('@/pages/admin/tamepulse/message/Index.vue')
        },

        // Store Locator
        {
            path: '/:tenantId/stores',
            name: 'store.index',
            component: () => import('@/pages/admin/store/Index.vue')
        },
        {
            path: '/:tenantId/stores/import',
            name: 'store.import',
            component: () => import('@/pages/admin/store/Import.vue')
        },

        // Menus
        {
            path: '/:tenantId/menus',
            name: 'menu.index',
            component: () => import('@/pages/admin/menu/Index.vue')
        },
        {
            path: '/:tenantId/menus/create',
            name: 'menu.create',
            component: () => import('@/pages/admin/menu/Create.vue')
        },
        {
            path: '/:tenantId/menus/:id/edit',
            name: 'menu.edit',
            component: () => import('@/pages/admin/menu/Edit.vue')
        },

        // Slotflow
        {
            path: '/:tenantId/slotflow/forms',
            name: 'slotflow.form.index',
            component: () => import('@/pages/admin/slotflow/form/Index.vue')
        },
        {
            path: '/:tenantId/slotflow/forms/create',
            name: 'slotflow.form.create',
            component: () => import('@/pages/admin/slotflow/form/Create.vue')
        },
        {
            path: '/:tenantId/slotflow/forms/:id/edit',
            name: 'slotflow.form.edit',
            component: () => import('@/pages/admin/slotflow/form/Edit.vue')
        },
        {
            path: '/:tenantId/slotflow/calendar-connections',
            name: 'slotflow.calendar-connection.index',
            component: () => import('@/pages/admin/slotflow/calendar-connection/Index.vue')
        },
        {
            path: '/:tenantId/slotflow/calendar-connections/create',
            name: 'slotflow.calendar-connection.create',
            component: () => import('@/pages/admin/slotflow/calendar-connection/Create.vue')
        },
        {
            path: '/:tenantId/slotflow/calendar-connections/:id/edit',
            name: 'slotflow.calendar-connection.edit',
            component: () => import('@/pages/admin/slotflow/calendar-connection/Edit.vue')
        },
        {
            path: '/:tenantId/slotflow/bookings',
            name: 'slotflow.booking.index',
            component: () => import('@/pages/admin/slotflow/booking/Index.vue')
        },
        {
            path: '/:tenantId/slotflow/submissions',
            name: 'slotflow.submission.index',
            component: () => import('@/pages/admin/slotflow/submission/Index.vue')
        },

        // Lead Capture
        {
            path: '/:tenantId/lead-capture/forms',
            name: 'lead-capture.form.index',
            component: () => import('@/pages/admin/lead-capture/form/Index.vue')
        },
        {
            path: '/:tenantId/lead-capture/forms/create',
            name: 'lead-capture.form.create',
            component: () => import('@/pages/admin/lead-capture/form/Create.vue')
        },
        {
            path: '/:tenantId/lead-capture/forms/:id/edit',
            name: 'lead-capture.form.edit',
            component: () => import('@/pages/admin/lead-capture/form/Edit.vue')
        },
        {
            path: '/:tenantId/lead-capture/submissions',
            name: 'lead-capture.submission.index',
            component: () => import('@/pages/admin/lead-capture/submission/Index.vue')
        },

        // Review Widget
        {
            path: '/:tenantId/review-widget/forms',
            name: 'review-widget.form.index',
            component: () => import('@/pages/admin/review-widget/form/Index.vue')
        },
        {
            path: '/:tenantId/review-widget/forms/create',
            name: 'review-widget.form.create',
            component: () => import('@/pages/admin/review-widget/form/Create.vue')
        },
        {
            path: '/:tenantId/review-widget/forms/:id/edit',
            name: 'review-widget.form.edit',
            component: () => import('@/pages/admin/review-widget/form/Edit.vue')
        },
        {
            path: '/:tenantId/review-widget/reviews',
            name: 'review-widget.review.index',
            component: () => import('@/pages/admin/review-widget/review/Index.vue')
        },

        // Custom Entity (route generiche per tutte le entità)
        {
            path: '/:tenantId/entity/:entityType',
            name: 'entity.index',
            component: () => import('@/pages/admin/entity/Index.vue')
        },
        {
            path: '/:tenantId/entity/:entityType/create',
            name: 'entity.create',
            component: () => import('@/pages/admin/entity/Create.vue')
        },
        {
            path: '/:tenantId/entity/:entityType/:id/edit',
            name: 'entity.edit',
            component: () => import('@/pages/admin/entity/Edit.vue')
        },

        // Entity Attributes
        {
            path: '/:tenantId/entity/:entityType/attributes',
            name: 'entity.attributes.index',
            component: () => import('@/pages/admin/entity-attribute/Index.vue')
        },
        {
            path: '/:tenantId/entity/:entityType/attributes/create',
            name: 'entity.attributes.create',
            component: () => import('@/pages/admin/entity-attribute/Create.vue')
        },
        {
            path: '/:tenantId/entity/:entityType/attributes/:id/edit',
            name: 'entity.attributes.edit',
            component: () => import('@/pages/admin/entity-attribute/Edit.vue')
        },

        // 404 Not Found
        {
            path: '/:pathMatch(.*)*',
            name: 'not-found',
            component: () => import('@/pages/NotFound.vue')
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        const preventScroll = window.history.state?.preventScroll
        if (preventScroll) return false
        return savedPosition || { top: 0 }
    }
})

router.beforeEach((to, from, next) => {
    previousRoute.value['original'] = from

    // Mantieni logica di previousRoute se necessaria
    if (!from.meta?.hasAction) {
        previousRoute.value['index'] = from
    }

    if (from.name === 'supplier-control-panel.product-translator') {
        previousRoute.value['productTranslatorIndex'] = from
    }

    next()
})
